import { useState } from "react";
import { Card } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import Button from "components/atoms/Button/Button";
import FileImportDialog from "./components/FileImportDialog.tsx/FileImportDialog";

export default function FileImport() {
  const [isFileImportDialogOpen, setIsFileImportDialogOpen] = useState(false);

  const handleFileImportDialogOpen = () => setIsFileImportDialogOpen(true);
  const handleFileImportDialogClose = () => setIsFileImportDialogOpen(false);

  return (
    <>
      {isFileImportDialogOpen && <FileImportDialog onClose={handleFileImportDialogClose} />}
      <Card body className="shadow-none quote-container h-100">
        <div className="d-flex flex-column h-100">
          <h4>
            <FormattedMessage id="settings.fileImportTools.fileImport" defaultMessage="File Import" />
          </h4>
          <p className="font-b3">
            <FormattedMessage
              id="settings.fileImportTools.createAndUpload"
              defaultMessage="Create a new file import and upload the data"
            />
          </p>
          <div className="d-flex justify-content-center align-items-center flex-grow-1">
            <Button
              variant="outline-primary"
              onClick={handleFileImportDialogOpen}
              label={<FormattedMessage id="settings.fileImportTools.createNewImport" defaultMessage="Create New Import" />}
            />
          </div>
        </div>
      </Card>
    </>
  );
}
